module.exports = __webpack_public_path__ + "img/icon1.90495135.png";